import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import store from './store'
import router from './router'
import MetaInfo from 'vue-meta-info'
import Print from 'vue-print-nb'
import Axios from 'axios'
import utils from '@/common/common.js'

Vue.use(MetaInfo)
Vue.use(Print)

// 富文本组件

import Editor from "@/components/Editor"

// 全局组件挂载

Vue.component('Editor', Editor)

Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$utils = utils

Vue.use(ElementUI)
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

new Vue({
	store,
	router,
	render: h => h(App),
}).$mount('#app')
